
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqVaXOJOEv9GGtydfNE3sq3nijb9tm83BsUVh6K4EFAGQMeta } from "/codebuild/output/src3535285525/src/src/pages/faq.vue?macro=true";
import { default as menux3XVhimLy05SHf6IqPw0u_45kpL06hfxDqh8gYbopBijAMeta } from "/codebuild/output/src3535285525/src/src/pages/menu.vue?macro=true";
import { default as index5SyJVZp4IS2LADGbhusnWjP3tHngoeM4dGMhUZXEGgUMeta } from "/codebuild/output/src3535285525/src/src/pages/index.vue?macro=true";
import { default as contactk8eR_YfSwVyKhbPwYC8_yiWlUi3h81LoUCp7CwPvYWUMeta } from "/codebuild/output/src3535285525/src/src/pages/contact.vue?macro=true";
import { default as tutorial93meE7RS8FS2Qk_ZuSnhwRczHdsXsSYgw_45III7Fw4BoMeta } from "/codebuild/output/src3535285525/src/src/pages/tutorial.vue?macro=true";
import { default as agreementIOOgrhYa46VMZFNYVk_PYA7zWkYVKvBAJWhdxIM3epQMeta } from "/codebuild/output/src3535285525/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass1hUJEgdddLqP4kdt1p7_niyujHl8dB4LgGGvjUOOhigMeta } from "/codebuild/output/src3535285525/src/src/pages/about-pass.vue?macro=true";
import { default as indexzWBL7TO8qPi0KgU4cla5mjBdHF_f3K5e2HYMU8RJUsEMeta } from "/codebuild/output/src3535285525/src/src/pages/card/index.vue?macro=true";
import { default as _91id_938r1HZsudyI_45t_XIoCaZ1_45F3UIcnBZy3vRNxQzBZ6OsYMeta } from "/codebuild/output/src3535285525/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceakxDdg9x1JdRm7lSfDCib0VFbqtkB1mj1hcq00B_45IaQMeta } from "/codebuild/output/src3535285525/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93JaZdsE2PcWHAJ_huJ4o3O01HQ5DAUpZmEtqGuqgmZd8Meta } from "/codebuild/output/src3535285525/src/src/pages/notice/[id].vue?macro=true";
import { default as indexsTukVwX0UqkrS_qFlTfPtx2cdjc6HHcpfb5LCZyA8SAMeta } from "/codebuild/output/src3535285525/src/src/pages/coupon/index.vue?macro=true";
import { default as indexsmB8G_450uNgvdBo4IDX7yx8H33UiS1Iyn00qaYkrSv_45IMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/index.vue?macro=true";
import { default as indexP0xkOTwH_45ZsfTm9aDaOytYgxXSSM7cOsmBdsTZzefQgMeta } from "/codebuild/output/src3535285525/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_939n8WXswFLUahA46lwxO3ztrxWQXTHHy_4594IZfvss804Meta } from "/codebuild/output/src3535285525/src/src/pages/parking/[id].vue?macro=true";
import { default as indexYn3nvUP66Pd9jaWPjUz__aYXzknQrLsoGo1BC49LxP0Meta } from "/codebuild/output/src3535285525/src/src/pages/history/index.vue?macro=true";
import { default as indextSmpbWKNRiILTPPTUi_d9UcVsrO99zv7QlXng1Fnm7gMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/index.vue?macro=true";
import { default as indexXo9Rzew8_2DJT_LR1eFgvmzw_45bxjhQhskZrFKryXpy0Meta } from "/codebuild/output/src3535285525/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexRa26gCYrcgXuiq84gErfUS3FFDedt8K7XWb5nuoPiGQMeta } from "/codebuild/output/src3535285525/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviJ3PJlyrj4CJ_7sBoj4Au5E2_45MTlQ7kv_45i_451oUta0d4cMeta } from "/codebuild/output/src3535285525/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editUIVC_vPxYSI5inpxAcj3xLT0oOEmdjBvThqwhlZ7_VMMeta } from "/codebuild/output/src3535285525/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementWvEYMn44Fu5NMyjkpbybVafY_45jhFtIE1oJVELQEY4bQMeta } from "/codebuild/output/src3535285525/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexAkQWSfEXw0H92UYm04M2vGjLqVRRmxarLtu0l7nUDAYMeta } from "/codebuild/output/src3535285525/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dPSnrKa_45MybMg5ngkm_45HyZB88hDpIcTfxspTe7kR_NTUMeta } from "/codebuild/output/src3535285525/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmJKU53mY1KScqINO2P5rt_1nGH_dYnL7ppHCcCCDHT6AMeta } from "/codebuild/output/src3535285525/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexK_45fVjEuZ2WUsL7jlwDGoZc48foFpGNbzlEgD7Eax8ZMMeta } from "/codebuild/output/src3535285525/src/src/pages/card/create/index.vue?macro=true";
import { default as indextA1iJgjxLO8G31UFRQ4D7gd1l7dGd_1rLJ_zlhkqX08Meta } from "/codebuild/output/src3535285525/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmaXltkQ5LxHlMjor_45JS4uKKg_WMxCnhsnjc3voa_w1mcMeta } from "/codebuild/output/src3535285525/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmPnYhXkOcyakJrPsGq97I8eg8gIgDT1o9IS0pDLZ1v4oMeta } from "/codebuild/output/src3535285525/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeFRJQCEE910pOKBDqlBkK_GkLzchc8yD94HTh3n7sNHYMeta } from "/codebuild/output/src3535285525/src/src/pages/membership/complete.vue?macro=true";
import { default as registerfrpjXEsJlS_459ff8SVW6kSC8HLWFVJ4iwwOl8eco7_hMMeta } from "/codebuild/output/src3535285525/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93C1ti47G88_456tVpjBPbrS2Um4NdBYkgYuYNF_45bb9o518Meta } from "/codebuild/output/src3535285525/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm_fFkMZ1AfhlSnlDZi8sTOBFDhUs_Q8I_45_7RmpmEtO_QMeta } from "/codebuild/output/src3535285525/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93TL7qLQRFeHAjxSIJv6idA66o2fyZJPzyaNcyR2UPIQAMeta } from "/codebuild/output/src3535285525/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexuP3gm4BZjeU1E2D2CjASKear_45DYvDdXB6tAwapBvGEoMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeaP1e_J0IuJsm1YGkqT9eLAWviHkC0mxFE75yueVUxuoMeta } from "/codebuild/output/src3535285525/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codexmt9i7UyhyoRKAy_IoRd3OowauWeS4u1yASzlS8FRjIMeta } from "/codebuild/output/src3535285525/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeR3A9J6eni3trE3dXfZu3Ib0mJENxcHxBfjKBue8jhtcMeta } from "/codebuild/output/src3535285525/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerDpv52ZlB6pyLuJHwybi5oCzWRAKtUDFVgebG23rlppMMeta } from "/codebuild/output/src3535285525/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete6KRu9PumS7X_45WUdRhj3_RyRzBmYVikKGd5vDJyi4ppMMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexC2CE0686VJPBSqjAOcfp7fv8TtXS1ujKRvdZTu1j0eQMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirme_msatEfthU4hN_45RcnuRHlXt3D21YuqHkAYU3EMmzXsMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completetS1gM82_4529IW7uZSKpq7NQX9kHQ_45HOJyA7Fyd4RXvx4Meta } from "/codebuild/output/src3535285525/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexqZtR35gZwkzI6BJZ1xJftM9_oVDHJS2OY9et9nHUKA0Meta } from "/codebuild/output/src3535285525/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93PTaWQqyXupxLeRjb7Xaxg744yPLNWjk_UzkVXt7TY8QMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeIkf71flhC6abs9D_459rTa_458wMBNZ4lCbWnVT3gPgudNYMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasGgFvlUje19DP9fK_45z_TujSymViZC8zazTkt3cOh15poMeta } from "/codebuild/output/src3535285525/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplemztL3Yi25ZDJ1zDtPYCrWWuOiGBIglUwunp3gEosmJUMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailq3vRfOqMvZTovHAFR11bMPFIEUmOYc3Tc8zPZ8P1fFMMeta } from "/codebuild/output/src3535285525/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmkfOA5BvZNZpcwva2eNsUWvnH_45Oi9FXbJ4w6wwEeJGJAMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentGeFM8chcoKb3MmV2CAaGdcvViBI_45ogaw_45IQQlhgaxgsMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmA7sNdx2MKzu_rLDqIpFOaeVindT2UHJhWhBskMxURi4Meta } from "/codebuild/output/src3535285525/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatef_458SaIF6MjAj5rOi9N1_456KIMex2xwGigHzkJ_exZ5xMMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete95WFjCb1KV2_GCl_XIwnUUlGWAyPt5zq6fEc3pkE_40Meta } from "/codebuild/output/src3535285525/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeAKbrbzkbebixBtPJoteSBujEfo5Bq4nYeOL2MZnY0W0Meta } from "/codebuild/output/src3535285525/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordlK2KEhaCpF4SOlEglh_ZKIhKz6dfeyHe4ReJ37AVyKIMeta } from "/codebuild/output/src3535285525/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliassPlGta_tlC46ROyjOm5YKFRvIGV2x71Yzqmr4jTnESIMeta } from "/codebuild/output/src3535285525/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerH8bGb74Ut8Gj1hAf_PoeUnzgAzkaffje1a_45xyO69fJsMeta } from "/codebuild/output/src3535285525/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeJRFLd_JR9iF0H1XHJbn2FRgdpDExfLBIPP2FeGxa9TkMeta } from "/codebuild/output/src3535285525/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexHnOxMtM41IR_45LCG_457gLUvfC_45VHA1_OVkzfjed5NjDBgMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index5kE0A8ToOxeCPTbSGyoe462bTTWERLpjNM883JBuksoMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index2tg1aPmMKCzgvHn2TxbKxDr4U2jXeg9aZQTKceupNrEMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexA_45My0M4HlapP_45uTBxTXXiogXM8gmMb0f7LGRvruQUtoMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatewxfZOZNuQLOLt_vC57swR6Q3JQKwzFmOQccBaJWloZwMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeXB4knE7eNM1CAN5bMTSoGOunGaUKiz14dmU2DY4nnpIMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmcOaNIWAQHmlbzZHE0mC4vb2HWr_7D3PIeAjIbDzwzB4Meta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexDQknc1RPK3TT6nX29W0698NMt3n1X0eImytz0StTs2YMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeHuxpZbhyNSs1Bl5NzCBFtMVgxgTMV31LH9UK0s_slrMMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateB8kTLPDlRB3Elw4JUBzn3BGW3OCrj6EXCjRSzIrU_459sMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexoELn4OfZKEL25khaFQeWjSYkP_TVSYNECz2eOWGZAB4Meta } from "/codebuild/output/src3535285525/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexnnDT0iiRHy9OhISRG5ORaM_45_YFiUdnTk047WQIJ5J6EMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completebG8ZfveqjDdCE3GWYuYCDJIkAf66xkx2bz0NFlGFk1sMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index6CU_45DJOXHcP2Mdlszx4inIn_4593mihVoXs1hFbqQHLiAMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code3B00su0akWSz_45DS6mjW4a0ULiuOGbrMG4JGJbITP2BkMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexCVXujMezwLParaGcrli6pBay4vdnr8SSqEdmYW5iwesMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexJBjrXSIGUJMkLOuIbsaRekpaP3N7_gS8MPwdEIAEsH8Meta } from "/codebuild/output/src3535285525/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexLu799KhNO6Tu8JnhR_NmlVQzQSOus2d2mru4wwVQ7mEMeta } from "/codebuild/output/src3535285525/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatenz7L_450F_Mf7FwaYjBC6m1jgABcE20tYOwOCW2d5VW3EMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmNVszp1SDPBq65Tb8uJvvu6YHDDiV5yRcV7Wqof4L7PYMeta } from "/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menux3XVhimLy05SHf6IqPw0u_45kpL06hfxDqh8gYbopBijAMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index5SyJVZp4IS2LADGbhusnWjP3tHngoeM4dGMhUZXEGgUMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexsTukVwX0UqkrS_qFlTfPtx2cdjc6HHcpfb5LCZyA8SAMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3535285525/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexYn3nvUP66Pd9jaWPjUz__aYXzknQrLsoGo1BC49LxP0Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3535285525/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexXo9Rzew8_2DJT_LR1eFgvmzw_45bxjhQhskZrFKryXpy0Meta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexRa26gCYrcgXuiq84gErfUS3FFDedt8K7XWb5nuoPiGQMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexK_45fVjEuZ2WUsL7jlwDGoZc48foFpGNbzlEgD7Eax8ZMMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmaXltkQ5LxHlMjor_45JS4uKKg_WMxCnhsnjc3voa_w1mcMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmPnYhXkOcyakJrPsGq97I8eg8gIgDT1o9IS0pDLZ1v4oMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3535285525/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeFRJQCEE910pOKBDqlBkK_GkLzchc8yD94HTh3n7sNHYMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerfrpjXEsJlS_459ff8SVW6kSC8HLWFVJ4iwwOl8eco7_hMMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm_fFkMZ1AfhlSnlDZi8sTOBFDhUs_Q8I_45_7RmpmEtO_QMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeaP1e_J0IuJsm1YGkqT9eLAWviHkC0mxFE75yueVUxuoMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codexmt9i7UyhyoRKAy_IoRd3OowauWeS4u1yASzlS8FRjIMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeR3A9J6eni3trE3dXfZu3Ib0mJENxcHxBfjKBue8jhtcMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerDpv52ZlB6pyLuJHwybi5oCzWRAKtUDFVgebG23rlppMMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirme_msatEfthU4hN_45RcnuRHlXt3D21YuqHkAYU3EMmzXsMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completetS1gM82_4529IW7uZSKpq7NQX9kHQ_45HOJyA7Fyd4RXvx4Meta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexqZtR35gZwkzI6BJZ1xJftM9_oVDHJS2OY9et9nHUKA0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeIkf71flhC6abs9D_459rTa_458wMBNZ4lCbWnVT3gPgudNYMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplemztL3Yi25ZDJ1zDtPYCrWWuOiGBIglUwunp3gEosmJUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailq3vRfOqMvZTovHAFR11bMPFIEUmOYc3Tc8zPZ8P1fFMMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmkfOA5BvZNZpcwva2eNsUWvnH_45Oi9FXbJ4w6wwEeJGJAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentGeFM8chcoKb3MmV2CAaGdcvViBI_45ogaw_45IQQlhgaxgsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmA7sNdx2MKzu_rLDqIpFOaeVindT2UHJhWhBskMxURi4Meta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete95WFjCb1KV2_GCl_XIwnUUlGWAyPt5zq6fEc3pkE_40Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeAKbrbzkbebixBtPJoteSBujEfo5Bq4nYeOL2MZnY0W0Meta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordlK2KEhaCpF4SOlEglh_ZKIhKz6dfeyHe4ReJ37AVyKIMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerH8bGb74Ut8Gj1hAf_PoeUnzgAzkaffje1a_45xyO69fJsMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeJRFLd_JR9iF0H1XHJbn2FRgdpDExfLBIPP2FeGxa9TkMeta || {},
    component: () => import("/codebuild/output/src3535285525/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3535285525/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]